module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-15.b0338758.png";